/* globals Regexp */
const phoneAndroid = /(Android).*(Chrome\/[.0-9]).*(Mobile)/gi;
const tabletAndroid = /(Android).*(Chrome\/[.0-9]).(?!.*Mobile).*/gi;


export default function () {
  let type = 'desktop';
  let environment = 'browser';

  const ua = navigator.userAgent;

  if (phoneAndroid.test(ua)) {
    type = 'phone';
    environment = 'android';
  }

  if (tabletAndroid.test(ua)) {
    type = 'tablet';
    environment = 'android';
  }

  return {
    type,
    environment,
  };
}



// WEBPACK FOOTER //
// ./src/modules/device.js